module.exports = __webpack_public_path__ + "static/media/1.1b2016d7.jpg";